import { React, Suspense, lazy } from "react";
import ReactGA from "react-ga";
import Ajankohtaista from "../Komponentit/Ajankohtaista";
import { Helmet } from "react-helmet";
// import loadable from '@loadable/component'

export default function Frontpage({ cookiesAccepted }) {
  const Facebook = lazy(() => import("../Komponentit/Facebook"));
  const Karuselli = lazy(() => import("../Komponentit/Karuselli"));
  const Banneri = lazy(() => import("../Komponentit/Banner"));
  const Myyntivinkit = lazy(() => import("../Komponentit/Myyntivinkit"));
  // const Facebook =  loadable(() => import('../Komponentit/Facebook'));
  // const Karuselli =  loadable(() => import('../Komponentit/Karuselli'));
  // const Banneri =  loadable(() => import('../Komponentit/Banner'));
  // const Myyntivinkit =  loadable(() => import('../Komponentit/Myyntivinkit'));

  ReactGA.pageview("/etusivu");

  return (
    <>
      <Helmet>
        <title>Kirppis Ruusunen</title>
        <meta name="robots" content="index, archive" />
        <meta
          name="description"
          content="Tervetuloa Kirppis Ruususen uusille verkkosivuille! Ylivieskan suurin kirpputori. Puh: 0405957281, kirppis.ruusunen@gmail.com"
        />
      </Helmet>
      <Banneri></Banneri>
      <div className="row ajankohtaista_FB">
        <div className="col-lg-4 ajankohtaista">
          <Suspense fallback={null}>
            <Ajankohtaista />
          </Suspense>
        </div>
        <div
          className={`${cookiesAccepted ? "col-lg-5" : "col-lg-8"} karuselli`}
        >
          <Suspense fallback={null}>
            <Karuselli></Karuselli>
          </Suspense>
        </div>

        {cookiesAccepted && (
          <div className="col-lg-3 FacebookBox">
            <Suspense fallback={null}>
              <Facebook></Facebook>
            </Suspense>
          </div>
        )}
      </div>
      <Suspense fallback={null}>
        <Myyntivinkit />
      </Suspense>
    </>
  );
}
